export default __webpack_public_path__ + "static/media/delete.1f909c2f.svg";